<header></header>
<div class="post-login-2">
    <div class="post-login-2-col-1 h-100">
        <app-left-panel-prelogin activeTab="2" *ngIf="this.auth?.detailuser == undefined && this.AccountType == 'C'"></app-left-panel-prelogin>
        <left-panel activeTab="2" *ngIf="this.auth?.detailuser != undefined && this.AccountType == 'C'"></left-panel>

        <app-left-panel-prelogin activeTab="2" *ngIf="this.auth?.detailuser == undefined  && this.AccountType == 'L'"></app-left-panel-prelogin>
        <left-panel activeTab="3" *ngIf="this.auth?.detailuser != undefined  && this.AccountType == 'L'"></left-panel>
    </div>
    <div class="post-login-2-col-2 has-banner">
    </div>
    <div class="post-login-2-col-3 bg-base-100 p-mobile-15 h-100vh">
        <grid-row class="justify-content-center h-100">
            <grid-col col="6" mobile="12">
                <grid-row class="mt-mobile-15 justify-content-center align-content-between h-100 pb-30">
                    <grid-col col="12">
                        <div class="font-400 font-size-24px color-base-700 line-h-32 text-align-center">
                            {{ "Howmuchwould" | translate }}
                        </div>
                    </grid-col>
                    <grid-col col="12">
                        <!-- Pay card  -->
                        <grid-row class="justify-content-center">
                            <grid-col col="10" mobile="12">
                                <!-- <grid-row class="justify-content-center mt-30 mt-mobile-15 align-content-center">
                                    <grid-col col="auto">
                                        <div class="font-400 font-size-32px line-h-40 color-base-500">
                                            {{"BHD" | translate}}
                                        </div>
                                    </grid-col>
                                    <grid-col col="3">
                                        <div class="form-group">
                                            <input class="show-amount" type="text" placeholder="5.0000"
                                            [ngModel]="this.amount"   (ngModelChange)="ngModelChange($event)">
                                        </div>
                                    </grid-col>
                                </grid-row> -->
                                <grid-row class="justify-content-center align-content-center mt-ipad-30">
                                    <grid-col col="2" mobile="2">
                                        <div class="pl-20 font-size-32px line-h-40 color-base-500">
                                            {{"BHD" | translate}}
                                        </div>
                                    </grid-col>
                                    <grid-col class="pl-30" col="10" mobile="6">
                                        <!-- <div class="form-group" *ngIf="this.flow == 'Quickpay' || this.flow == 'Pay'">
                                            <input class="show-amount" type="number" placeholder="5.000" (keypress)="keypress($event)"  *ngIf="this.amountchnged == false"  
                                                [ngModel]="this.amount" (ngModelChange)="ngModelChange($event)">

                                                <input class="show-amount" type="number" placeholder="5.000" (keypress)="keypress($event)"  *ngIf="this.amountchnged == true"  
                                                [ngModel]="this.amountfixed | amountFormatter" (ngModelChange)="ngModelChange($event)">
                                           
                                        
                                          
                                        </div> -->
                                            <!-- [ngModel]="this.amount| amountFormatter"   (ngModelChange)="ngModelChange($event)" -->
                                            <!--(ngModelChange)="this.amount = $event" <span >100.000 </span> -->

                                        <div class="form-group" *ngIf="this.flow == 'Quickpay' || this.flow == 'Pay'">
                                            <input
                                              class="show-amount"
                                              type="number"
                                              placeholder="5.000"
                                              (blur)="quickOnblur($event)" 
                                              *ngIf="this.amountchnged == false"
                                              [ngModel]="this.amount"
                                           
                                            >
                                            <input
                                              class="show-amount"
                                              type="number"
                                              placeholder="5.000"
                                              (blur)="quickOnblur($event)" 
                                              *ngIf="this.amountchnged == true"  
                                              [ngModel]="this.amountfixed | amountFormatter"
                                            >
                                          </div>



                                        <!-- <div class="form-group" *ngIf="this.flow != 'Quickpay' && this.flow != 'Pay'">
                                            <input class="show-amount" type="number" placeholder="5.000" (keypress)="keypress($event)" [ngModel]="this.Inquireamount" (ngModelChange)="ngModelChange($event)"
                                            *ngIf="this.amountchnged == false" >

                                                <input class="show-amount" type="number" placeholder="5.000" (keypress)="keypress($event)" [ngModel]="this.amountfixed | amountFormatter" (ngModelChange)="ngModelChange($event)"
                                                *ngIf="this.amountchnged == true" >
                                                [(ngModel)]="this.Inquireamount" -->
                                             
                                        <!-- </div>  -->

                                        <div class="form-group" *ngIf="this.flow != 'Quickpay' && this.flow != 'Pay'">
                                            <input
                                              class="show-amount"
                                              type="number"
                                              placeholder="5.000"
                                              (blur)="onBlur($event)" 
                                              [ngModel]="this.Inquireamount" 
                                           
                                              *ngIf="this.amountchnged == false"
                                            >
                                            <input
                                              class="show-amount"
                                              type="number"
                                              placeholder="5.000"
                                              (blur)="onBlur($event)" 
                                              [ngModel]="this.amountfixed | amountFormatter" 
                                       
                                              *ngIf="this.amountchnged == true"
                                            >
                                          </div>
                                       

                                    </grid-col>
                                </grid-row>
                                <div class="font-600 font-size-14px color-error line-h-18 mt-20 text-align-center" *ngIf="this.decimalErro == true">
                                    {{ "AmountCanbeUpto3deci" | translate }}
                                </div>
                                <div class="font-400 font-size-14px color-base-500 line-h-18 mt-20 text-align-center">
                                    {{ "MinAmount5k" | translate }}
                                </div>

                            </grid-col>

                        </grid-row>
                        <grid-row class="custom-tabs-tags col-space-min justify-content-center mt-30"
                            *ngIf="this.flow == 'Inquire'">
                            <grid-col col="4" mobile="12" class="mt-ipad-15">
                                <div class="custom-tabs-tags-item" [ngClass]="activeTab == 1 ? 'active' : ''"
                                    (click)="changeTab(1)">
                                    <div
                                        class="font-400 font-size-10px color-base-500 line-h-12 text-align-center letter-spacing-1">
                                        {{ "OutstandingAmount" | translate }}
                                    </div>
                                    <div
                                        class="font-600 font-size-14px color-base-700 line-h-22 mt-10 text-align-center letter-spacing-03">
                                        {{ "BHD" | translate }} {{this.amountdetail?.outStandingAmount}}
                                    </div>
                                </div>
                            </grid-col>
                            <grid-col col="4" mobile="12" class="mt-ipad-15">
                                <div class="custom-tabs-tags-item" [ngClass]="activeTab == 2 ? 'active' : ''"
                                    (click)="changeTab(2)">
                                    <div
                                        class="font-400 font-size-10px color-base-500 line-h-12 text-align-center letter-spacing-1">
                                        {{ "StatementAmount" | translate }}
                                    </div>
                                    <div
                                        class="font-600 font-size-14px color-base-700 line-h-22 mt-10 text-align-center letter-spacing-03">
                                        {{ "BHD" | translate }} {{this.amountdetail?.lastStatementRemAmount}}
                                    </div>
                                </div>
                            </grid-col>
                            <grid-col col="4" mobile="12" class="mt-ipad-15">
                                <div class="custom-tabs-tags-item" [ngClass]="activeTab == 3 ? 'active' : ''"
                                    (click)="changeTab(3)">
                                    <div
                                        class="font-400 font-size-10px color-base-500 line-h-12 text-align-center letter-spacing-1">
                                        {{ "MinimumAmount" | translate }}
                                    </div>
                                    <div
                                        class="font-600 font-size-14px color-base-700 line-h-22 mt-10 text-align-center letter-spacing-03">
                                        {{ "BHD" | translate }} {{this.amountdetail?.minimumAmount}}
                                    </div>
                                </div>
                            </grid-col>
                        </grid-row>


                        <grid-row class="custom-tabs-tags col-space-min justify-content-center mt-30"
                            *ngIf=" this.AccountType  == 'L' && this.flow != 'Quickpay' && this.flow !='Inquire' && this.flow !='Pay'">

                            <grid-col col="6" mobile="12" class="mt-ipad-15" *ngIf="this.LoanDetail != null">
                                <div class="custom-tabs-tags-item" [ngClass]="activeTab == 1 ? 'active' : ''"
                                    (click)="changeLoanTab(1)">
                                    <div
                                        class="font-400 font-size-10px color-base-500 line-h-12 text-align-center letter-spacing-1">
                                        {{ "InstalmentAmount" | translate }}
                                    </div>
                                    <div
                                        class="font-600 font-size-14px color-base-700 line-h-22 mt-10 text-align-center letter-spacing-03">
                                        {{ "BHD" | translate }} {{this.LoanDetail[0]?.installmentAmount}}
                                    </div>
                                </div>
                            </grid-col>
                            <grid-col col="6" mobile="12" class="mt-ipad-15" *ngIf="this.LoanDetail != null">
                                <div class="custom-tabs-tags-item" [ngClass]="activeTab == 2 ? 'active' : ''"
                                    (click)="changeLoanTab(2)">
                                    <div
                                        class="font-400 font-size-10px color-base-500 line-h-12 text-align-center letter-spacing-1">
                                        {{ "OverdueAmount" | translate }}
                                    </div>
                                    <div
                                        class="font-600 font-size-14px color-base-700 line-h-22 mt-10 text-align-center letter-spacing-03">
                                        {{ "BHD" | translate }} {{this.LoanDetail[0]?.overdueAmount}}

                                    </div>
                                </div>
                            </grid-col>
                        </grid-row>



                        <grid-row class="col-space-min justify-content-center mt-30"
                            *ngIf=" this.AccountType  == 'C' && this.flow != 'Quickpay' && this.flow !='Inquire' && this.flow !='Pay'">
                            <grid-col col="9" mobile="12">

                                <grid-col col="3" mobile="12" class="mt-ipad-15">

                                    <div class="custom-radio mt-30">
                                        <input type="radio" value="Outstanding amount" id="radio-3"
                                            (change)="onAmountChange(1,$event)" name="radioGroup2">
                                        <label for="radio-3">
                                            <grid-row class="justify-content-between align-item-center"
                                                *ngIf="this.CardDetail != null">
                                                <grid-col col="auto">
                                                    <div class="font-400 font-size-10px line-h-12">
                                                        {{"OutstandingAmount" | translate}}
                                                    </div>

                                                </grid-col>
                                                <grid-col col="auto">
                                                    <div class="font-500 font-size-14px line-h-20">
                                                        {{this.CardDetail[0]?.cardCurrencyISO}}
                                                        {{this.CardDetail[0]?.outstandingAmount}}
                                                    </div>
                                                </grid-col>
                                            </grid-row>
                                        </label>
                                    </div>
                                </grid-col>
                                <grid-col col="3" mobile="12" class="mt-ipad-15">

                                    <div class="custom-radio mt-10">
                                        <input type="radio" value="Statement amount" id="radio-4"
                                            (change)="onAmountChange(2,$event)" name="radioGroup2">
                                        <label for="radio-4">
                                            <grid-row class="justify-content-between align-item-center"
                                                *ngIf="this.CardDetail != null">
                                                <grid-col col="auto">
                                                    <div class="font-400 font-size-10px line-h-12">
                                                        {{"StatementAmount" | translate}}
                                                    </div>

                                                </grid-col>
                                                <grid-col col="auto">
                                                    <div class="font-500 font-size-14px line-h-20">
                                                        <!-- According to ghufranlastStatementAmount to lastStatementRemAmount  -->
                                                        {{ this.CardDetail[0]?.cardCurrencyISO}}
                                                        {{this.CardDetail[0]?.lastStatementRemAmount}}
                                                    </div>
                                                </grid-col>
                                            </grid-row>
                                        </label>
                                    </div>
                                </grid-col>
                                <grid-col col="3" mobile="12" class="mt-ipad-15">

                                    <div class="custom-radio mt-10">
                                        <input type="radio" value="Minimum amount" id="radio-5"
                                            (change)="onAmountChange(3,$event)" name="radioGroup2">
                                        <label for="radio-5">
                                            <grid-row class="justify-content-between align-item-center"
                                                *ngIf="this.CardDetail != null">
                                                <grid-col col="auto">
                                                    <div class="font-400 font-size-10px line-h-12">
                                                        {{"MinimumAmount" | translate}}
                                                    </div>

                                                </grid-col>
                                                <grid-col col="auto">
                                                    <div class="font-500 font-size-14px line-h-20">
                                                        {{this.CardDetail[0]?.cardCurrencyISO}}
                                                        {{this.CardDetail[0]?.minimumAmountDue}}
                                                    </div>
                                                </grid-col>
                                            </grid-row>
                                        </label>
                                    </div>
                                </grid-col>
                            </grid-col>
                        </grid-row>
                    </grid-col>
                    <grid-col col="12">
                        <!-- <grid-row class="justify-content-center">
                            <grid-col col="12" mobile="12">
                                <button class="btn-back" (click)="back2()">
                                    <i class="icon-back"></i>
                                </button>
                                <button class="btn-dft mt-15 mt-ipad-30 mb-ipad-20" [disabled]="isValid()"
                                    (click)="selectPaymentMethod()">
                                    {{ "PAY" | translate }}
                                </button>

                            </grid-col>
                        </grid-row> -->
                        <grid-row class="justify-content-between mt-50">
                            <!-- <grid-col col="auto">
                              <button class="btn-back" (click)="back2()">
                                <i class="icon-back"></i>
                              </button>
                            </grid-col>
                            <grid-col col="auto">
                                <button class="btn-back" (click)="back3()">
                                  <i class="icon-back"></i>
                                </button>
                              </grid-col> -->
                              <grid-col col="auto" *ngIf="cardPay !== 'directcard'">
                                <button class="btn-back" (click)="back2()">
                                  <i class="icon-back"></i>
                                </button>
                              </grid-col>
                              
                              <grid-col col="auto" *ngIf="cardPay === 'directcard'">
                                <button class="btn-back" (click)="back3()">
                                  <i class="icon-back"></i>
                                </button>
                              </grid-col>
                              
                            <grid-col col="9">
                              <button class="btn-dft" [disabled]="isValid()" (click)="selectPaymentMethod()">
                                {{ "PAY" | translate }}
                              </button>
                            </grid-col>
                          </grid-row>
                    </grid-col>
                </grid-row>
            </grid-col>
        </grid-row>
    </div>
</div>